import { Cost } from "./cost.model";
import { CreateCost } from "./create-cost.model";

export class EditCost extends CreateCost {
    constructor(
        readonly id: Cost["id"],
        entityId: CreateCost["entityId"],
        invoiceNum: CreateCost["invoiceNum"],
        concept: CreateCost["concept"],
        issuerName: CreateCost["issuerName"],
        issuerIdentificationType: CreateCost["issuerIdentificationType"],
        identificationNumber: CreateCost["identificationNumber"],
        type: CreateCost["type"],
        subtype: CreateCost["subtype"],
        invoiceDate: CreateCost["invoiceDate"],
        paymentDate: CreateCost["paymentDate"],
        paymentMethod: CreateCost["paymentMethod"],
        base: CreateCost["base"],
        iva: CreateCost["iva"],
        otherIva: CreateCost["otherIva"],
        discount: CreateCost["discount"],
        total: CreateCost["total"],
        irpfType: CreateCost["irpfType"],
        territory?: CreateCost["territory"],
        othersType?: CreateCost["othersType"],
        otherPaymentMethod?: CreateCost["otherPaymentMethod"],
        document?: CreateCost["document"],
        additionalExpensesToUpdate?: CreateCost["additionalExpensesToUpdate"],
        category?: CreateCost["category"],
        otherCategory?: CreateCost["otherCategory"],
        lines?: CreateCost["lines"],
        paymentInstallments?: CreateCost["paymentInstallments"],
    ) {
        super(
            entityId,
            invoiceNum,
            concept,
            issuerName,
            issuerIdentificationType,
            identificationNumber,
            type,
            subtype,
            invoiceDate,
            paymentDate,
            paymentMethod,
            base,
            iva,
            otherIva,
            discount,
            total,
            irpfType,
            territory,
            othersType,
            otherPaymentMethod,
            document,
            additionalExpensesToUpdate,
            category,
            otherCategory,
            lines,
            paymentInstallments,
        );
    }
}
